// Generated by BUCKLESCRIPT VERSION 5.0.3, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css/src/Css.js");
var Soon = require("./Soon.bs.js");
var React = require("react");
var Checkmark = require("./Checkmark.bs.js");

var container = Css.merge(/* :: */[
      Css.style(/* :: */[
            Css.alignItems(/* center */98248149),
            /* :: */[
              Css.display(/* flex */-1010954439),
              /* :: */[
                Css.flexBasis(Css.pct(40)),
                /* :: */[
                  Css.height(Css.em(2)),
                  /* [] */0
                ]
              ]
            ]
          ]),
      /* :: */[
        Css.style(/* :: */[
              Css.media("(min-width: 53.125em)", /* :: */[
                    Css.flexBasis(Css.pct(35)),
                    /* [] */0
                  ]),
              /* [] */0
            ]),
        /* [] */0
      ]
    ]);

var Styles = /* module */[/* container */container];

function Feature(Props) {
  var emoji = Props.emoji;
  var text = Props.text;
  return React.createElement("div", {
              className: container
            }, emoji ? React.createElement(Soon.make, { }) : React.createElement(Checkmark.make, { }), React.createElement("h3", undefined, text));
}

var make = Feature;

exports.Styles = Styles;
exports.make = make;
/* container Not a pure module */
